import { plugin as networkBreadcrumbsPlugin } from "@appsignal/plugin-breadcrumbs-network"
import { plugin as pathDecoratorPlugin } from "@appsignal/plugin-path-decorator"
import { installErrorHandler } from "@appsignal/stimulus"
import { Application } from "@hotwired/stimulus"
import { registerDirectUploadFieldController } from "@swiftvee/bootstrap-concerns"
import appsignal from "../lib/appsignal"

const application = Application.start()

// Configure Stimulus development experience
application.warnings = true
application.debug = false
window.Stimulus = application

if (appsignal) {
  ;[networkBreadcrumbsPlugin, pathDecoratorPlugin].forEach(plugin => {
    appsignal.use(plugin())
  })
  installErrorHandler(appsignal, application)
}

registerDirectUploadFieldController(application)

export { application }
